import ReactSelect from "react-select";
import { createSelect } from "./createSelect";
export var Select = createSelect(ReactSelect);
